<style lang="sass" scoped>
.part-title
    text-align: center
    border-bottom: 1px solid #e9e9e9
    height: 50px
    .fr
        font-weight: 400
        width: 100px
        height: 28px
        line-height: 28px
        border: 1px solid #d4d4d4
        border-radius: 4px
        font-size: 14px
        cursor: pointer

.box
    border: 1px solid #e9e9e9
    border-radius: 4px
    height: calc(100% - 90px)
    margin-top: 20px
    .top
        height: 50px
        background: #FBFCFD
        padding-left: 20px
        border-radius: 4px 4px 0 0
        padding-top: 10px
        font-size: 16px
        font-weight: 550
        border-bottom: 1px solid #EAEBF0
        ::v-deep .el-select
            margin-left: 10px
            .el-input__suffix
                .el-icon-arrow-up
                    right: 0
            input
                width: 120px

        ::v-deep .el-date-editor
            width: 200px
            margin-left: 10px
            padding: 3px 0
            .el-icon-date
                display: none
            .el-range-separator
                width: 20px
            input
                width: 80px

.echart
    background: #fff
    padding: 0 20px
    overflow-y: auto
    margin-bottom: 20px
    width: 100%
    position: relative
    height: calc(100% - 50px)
    .none
        position: absolute
        top: 50%
        left: 50%
        transform: translate(-50%, -50%)

    .pie
        padding: 40px
        border-bottom: 1px solid #e9e9e9
        // min-width: 970px
        display: flex
        // -webkit-box-pack: center
        justify-content: center
        // -webkit-box-align: center
        align-items: center
        #pie
            display: inline-block
            width: 180px
            height: 180px
        .list
            margin-left: 50px
            // width: 660px
            // float: left
            // display: inline-block
            vertical-align: middle
            text-align: center
        .half
            width: 310px
            line-height: 30px
            float: left
            margin: 10px
            background: #fafafa
            border: 1px solid #e9e9e9
            cursor: default
            border-radius: 4px
            padding: 0 5px 0 10px
            &:hover, &.hover
                border: 1px solid #fff
                background: #fff
                box-shadow: 0px 2px 10px 0px rgba(59, 63, 69, 0.16)
            span
                display: inline-block
            > span
                width: 20%
                margin-right: 1%
                text-align: right
                &:first-child
                    width: 38%
                    text-align: left
                &:last-child
                    margin-right: 0
                    width: 38%
                .color
                    width: 20px
                    height: 8px
                    border-radius: 1px
                    margin-right: 5px
                .els
                    width: calc(100% - 25px)

    #bar
        width: 100%
        height: 430px

        ::v-deep .tooltip
            font-size: 12px
            text-align: right
            td
                width: 70px
            .first
                width: auto
                text-align: left
            .color
                display: inline-block
                width: 10px
                height: 10px
                border-radius: 1px
                margin-right: 5px

    .tip
        text-align: center
        img
            height: 20px

</style>

<template lang="pug">
div(style="height: 100%;")
    .part-title
        .fl(style="margin-top: 8px;") 流量详情
        span(style="position: relative;left: 13px;")
            el-radio-group(v-model="tabType")
                el-radio-button(label="1") 通用数据
                el-radio-button(label="2") 专业数据
        .fr(@click="goBack")
            i.el-icon-arrow-left
            | 返回

    .box
        .top 数据分析
            template(v-if="tabType == 1")
                el-select(v-model="flowType" size="mini")
                    el-option(v-for="{ dictItemName, dictItemDesc } in flowTypes" :key="dictItemName" :label="dictItemName" :value="dictItemDesc") {{ dictItemName }}
            el-date-picker(
                v-model="flowTime" size="mini" type="daterange" value-format="yyyy-MM-dd" format="yyyy-MM-dd" :clearable="false"
                start-placeholder="开始日期" end-placeholder="结束日期" range-separator="至"
                :picker-options="pickerOptions")

        div(v-if="tabType == 2" style="height: calc(100% - 50px);min-width: 1080px;overflow: auto;")
            FlowPro(:codes="codes" :time="flowTime" ref="FlowPro")

        template(v-else)
            .echart
                .none(v-if="isNoData") 暂无数据
                template(v-if="!isNoData")
                    .pie(ref="pie")
                        #pie
                        .list(ref="list")
                            .half(
                                v-for="({ labelName, humanpropertyNum, rate, hover, color }, i) in pieData" :key="labelName + rate"
                                @mouseover="hoverItem(labelName)" @mouseout="hoverItem('')" :class="{ 'hover': hover }")
                                span
                                    span.color(:style="{ background: color }")
                                    span.els.fr {{ labelName }}
                                span {{ rate == '--' ? '--' : rate + '%' }}
                                span {{ humanpropertyNum }}人次
                            .clear
                    div
                        #bar
                        .tip
                            img(src="../../assets/cvs_tip.png")

</template>

<script>
import echarts from 'echarts'
import SexRate from './SexRate'
import FlowPro from './FlowPro'

export default {
    name: "CrowdData",
    props: [ 'codes', 'time', 'value', 'orders' ],
    components: { SexRate, FlowPro },
    data () {
        let _this = this
        return {
            tabType: '1',
            // colors: ['#5617CC', '#CC1CB9', '#FF3686', '#F5810F', '#E7BD00', '#56F5BA', '#49D7FB', '#3083F2'],
            colors: ['#EA1F64', '#9D27B0', '#673BB8', '#2324FF', '#2274F3', '#02AAF4', '#08D5ED', '#009688', '#4DAF51', '#8BC34A', '#CDDC39', '#FFEB3B', '#FFC106', '#FF9900', '#FF5723', '#F44336'],
            flowType: '',
            flowTypes: [],
            pieData: [],
            barData: [],
            barSeries: [], // 缓存折线图 series 数据
            pieStrData: { label: '触达总流量', num: 0 },
            startTime: '',
            endTime: '',
            flowTime: this.handleTime(this.time), // 初始化展示时间范围
            barChart: null,
            pieChart: null,
            pickerOptions: {
                disabledDate (date) {
                    let time = _this.handleTime(_this.time)
                    let getTimeDate = new Date(date).setHours(0)
                    return getTimeDate > new Date(time[1]).setHours(0) || getTimeDate < new Date(time[0]).setHours(0)
                }
            },
            canReq: false,
            isNoData: true,

            sexData: { title: '人群分布', list: [] },
            activeSexData: { title: '', list: [] },

            orderCode: '',

            showPf: false,
            newPfNames: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O'],
            newPfs: [],

            userPfList: [],
            chooseUserPf: [],
            curActiveUpfIdx: -1,
            curActiveUpf: null,

            showDelConfirm: false,
            delUserPf: null
        }
    },
    computed: {
        newPfName () {
            return this.newPfNames[this.newPfs.length]
        }
    },
    created () {
        this.getFlowTypes()
        if (!this.$store.state.label.list.length) this.$store.dispatch('label/getSearchLabels') // 标签Label
    },
    watch: {
        tabType (v) {
            if (v == 1) {
                let types0 = this.flowTypes[0]
                if (types0) {
                    // 重置回第一个选项 可能回多次请求 增加判断控制
                    if (this.flowType == types0.dictItemDesc || '') this.getFlowDetail()
                    else this.flowType = types0.dictItemDesc || ''
                }
            }
            if (v == 2) {
                this.$nextTick(() => {
                    this.$refs.FlowPro.getSexData()
                })
            }
        },
        flowType () {
            if (this.tabType == 1) this.getFlowDetail()
        },
        flowTime () {
            if (this.tabType == 1) this.getFlowDetail()
            if (this.tabType == 2) {
                this.$nextTick(() => {
                    this.flowProReq()
                })
            }
        },
        time (v) {
            this.flowTime = this.handleTime(v)
        },
        '$store.state.common.flowTypes': {
            immediate: true,
            handler (v) {
                if (v && v.length && !this.flowTypes.length) { // 初始化flowTypes
                    this.flowTypes = v
                    this.flowType = v[0].dictItemDesc
                }
            }
        },
        value (v) {
            if (v) {
                this.$nextTick(() => {
                    this.canReq = true
                    this.getFlowDetail()
                })
            }
        }
    },
    mounted () {
        window.addEventListener('resize', () => {
            this.handleChart()
            this.handleListW()
        })
    },
    methods: {
        flowProReq () {
            this.$refs.FlowPro.getSexData()
            this.$refs.FlowPro.getOrdersUPFs()
        },
        handleListW () {
            this.$nextTick(() => {
                if (this.$refs.pie) {
                    let listMaxL = this.$refs.pie.clientWidth - 180 - 80 - 50
                    let w = listMaxL - listMaxL % 330
                    if (this.pieData.length < 3) w = this.pieData.length * 330 + 'px'
                    this.$refs.list.style.width = w + 'px'
                }
            })
        },
        initFlowtype () {
            if (this.flowTypes.length) {
                let first = this.flowTypes[0].dictItemDesc || ''
                if (this.flowType != first) this.flowType = first
            }
        },
        goBack () {
            this.canReq = false
            this.initFlowtype()
            this.tabType = 1
            this.$emit('back', false)
        },
        hoverItem (labelName) {
            // 饼图对应数据高亮
            let idx = labelName ? this.pieData.map(el => el.labelName).indexOf(labelName) : -1
            this.pieHighLight(idx)
            // 折线图对应数据高亮
            let barIdx = labelName ? this.barSeries.map(el => el.label).indexOf(labelName) : -1
            this.barLineHighLight(barIdx)
        },
        barLineHighLight (idx) {
            this.barSeries.forEach((el, i) => { // 先取消全部高亮
                this.barChart.dispatchAction({ type: 'downplay', seriesIndex: i })
            })
            idx > -1 && this.barChart.dispatchAction({ type: 'highlight', seriesIndex: idx })
        },
        pieHighLight (idx) {
            this.pieData.forEach((el, i) => { // 全部取消高亮
                this.pieChart.dispatchAction({ type: 'downplay', dataIndex: i })
            })
            idx > -1 && this.pieChart.dispatchAction({ type: 'highlight', dataIndex: idx })
        },
        handleTime (v) { // 处理初始化时间 '2020-01-01 ~ 03-03' => ['2020-01-01', '2020-03-03]
            let splits = v.split('~').map(el => el.trim())
            if (splits.length === 1) return [splits[0], splits[0]]
            if (splits[1] && splits[1].length < 10) splits[1] = splits[0].split('-')[0] + '-' + splits[1]
            return splits
        },
        async getFlowTypes() { // 获取类型列表
            let data = this.$store.state.common.flowTypes
            if (!data.length) this.$store.dispatch('getDictItemListFromUrl', { key: 'flowTypes', url: '/adr/devicelabel/getProLabelDic' })
        },
        async getFlowDetail () {
            if (!this.canReq) return
            if (!this.flowType) return
            if (!this.flowTime || !this.flowTime[0] || !this.flowTime[1]) return
            let [ startDate, endDate ] = this.flowTime
            let res = await this.fetch('/adr/order/v2/advert-flowrates/' + this.flowType, {
                orderCodeList: this.codes, startDate, endDate
            }, 'get')
            if (res && res.code === 0) {
                let propFlow = res.data || {}
                let { flowrateNum, humanpropertyLabelList, humanpropertyTimeList } = propFlow
                if (flowrateNum && humanpropertyLabelList.length && humanpropertyTimeList.length) {
                    this.isNoData = false
                } else {
                    this.isNoData = true
                    return
                }
                this.pieStrData.num = flowrateNum
                this.handleFlowData(humanpropertyLabelList, humanpropertyTimeList, flowrateNum)
                this.$nextTick(() => {
                    this.pieChart = echarts.init(document.querySelector('#pie'))
                    this.barChart = echarts.init(document.querySelector('#bar'))
                    this.handleChart()
                    this.handleListW()
                })
            } else {
                this.isNoData = true
            }
        },
        handleFlowData (pieList, barList, allNum) { // 处理饼图数据和柱状图数据
            this.pieData = this.fillData(pieList, allNum)
            this.barData = barList.map(el => {
                this.fillData(el.humanpropertyLabelList, allNum, el.humanpropertyNum)
                return el
            })
        },
        fillData (list, allNum, curAllNum) { // 处理比例和未知数据
            if (!list.length) return []
            let allZero = !allNum || allNum == 0
            let argsLen = arguments.length // 参数个数 处理折线图 barData 时会传入3个数据
            list.forEach((el, i) => {
                el.rate = !allZero ? ((el.humanpropertyNum / allNum) * 100).toFixed(2) - 0 : '--'
                if (argsLen == 3) {
                    // 折线图hover时 显示的比例 和 联动的饼图展示的比例意义有点区别  须展示两套内容  增加全天占比 比例的计算
                    el.allDayRate = el.rate // 全天占比 分母依然是所有时段的总和 allNum
                    // 饼图中展示的当前hover时段的占比 分母为 当前时段的总和
                    el.rate = curAllNum > 0 ? ((el.humanpropertyNum / curAllNum) * 100).toFixed(2) - 0 : '--'
                }
                el.hover = false
                el.color = this.colors[i]
            })
            let unKnow = list.reduce( // 处理未知剩余的数据
                (res, cur) => {
                    res.humanpropertyNum = res.humanpropertyNum - cur.humanpropertyNum
                    res.rate = !allZero ? (res.rate - cur.rate).toFixed(2) - 0 : '--'
                    return res
                },
                {
                    labelName: '其他', hover: false, rate: 100,
                    color: this.colors[list.length] || '#999',
                    humanpropertyNum: argsLen == 3 ? curAllNum : allNum
                }
            )
            if (argsLen == 3) {
                unKnow.allDayRate = (unKnow.humanpropertyNum / allNum * 100).toFixed(2) // 全天占比 分母依然是所有时段的总和 allNum
            }
            if (this.flowType != 'SEX' && this.flowType != 'AGE') list.push(unKnow) // 性别和年龄不展示其他
            return list
        },
        drawPie () {
            if (!this.pieChart) return
            this.draw(this.pieChart, {
                color: this.colors,
                series: [
                    {
                        type:'pie',
                        radius: ['80%', '88%'],
                        avoidLabelOverlap: false,
                        label: {
                            normal: {
                                show: true, position: 'center', formatter: `{b|${this.pieStrData.num}}\n{a|触达总流量(人次)}`,
                                rich: {
                                    a: { fontSize: 14, color: '#878A92' },
                                    b: { fontSize: 32, color: '#3B3F45', fontFamily: 'Akrobat-ExtraBold' }
                                }
                            }
                        },
                        data: this.pieData.map(el => el.rate)
                    }
                ]
            })
            let allHoverFalse = () => {
                this.pieData.forEach(el => { el.hover = false })
                this.barLineHighLight(-1)
            }
            this.pieChart.on('mouseover', e => {
                allHoverFalse()
                let item = this.pieData[e.dataIndex]
                item.hover = true
                this.barLineHighLight(this.barSeries.map(el => el.label).indexOf(item.labelName))
            })
            this.pieChart.on('mouseout', allHoverFalse)
        },
        handleBarOptData () { // 处理柱状图需要的X轴数据和series数据
            if (!this.barData.length) return { xData: [], series: [] }
            return this.barData.reduce((res, cur) => {
                // xData
                let name = cur.timeSegmentName
                res.xData.push(name)
                // series 每一个的humanpropertyLabelList中的相同labelName的数据整合到series中同一类去
                 let series = res.series
                let sorts = series.map(el => el.label)
                cur.humanpropertyLabelList.forEach(el => {
                    let label = el.labelName
                    let curLabelIdx = sorts.indexOf(label)
                    let value = el.humanpropertyNum
                    if (curLabelIdx > -1) series[curLabelIdx].data.push(value)
                    else series.push({ label, type: 'line', data: [ value ] })
                })
                return res
            }, { xData: [], series: [] })
        },
        drawBar () {
            if (!this.barChart) return
            let { xData, series } = this.handleBarOptData()
            this.barSeries = series
            let cvsSet = { // 线条相关配置
                // boundaryGap: false, // x y轴起点在一起
                axisLine: { show: false, lineStyle: { color: '#878A92', type: 'dashed' } },
                splitLine: { show: true, lineStyle: { color: '#e9e9e9', type: 'dashed' } },
                axisTick: { lineStyle: { color: '#FFF' } }
            }
            this.draw(this.barChart, {
                color: this.colors,
                xAxis: { type: 'category', data: xData, ...cvsSet },
                yAxis: { type: 'value', ...cvsSet },
                series,
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'shadow', shadowStyle: { color: 'rgba(40,39,41,0.05)' } },
                    formatter: data => {
                        let item = this.barData[data[0].dataIndex]
                        if (item && item.humanpropertyLabelList) {
                            return `
                                <table class="tooltip">
                                    <tr><th style="text-align: center;">类型</th><th>全天占比</th><th>人次</th></tr>
                                    ${
                                        (item.humanpropertyLabelList || []).map(el => {
                                            let rate = el.allDayRate
                                            return `
                                                <tr>
                                                    <td class="first"><span class="color" style="background:${ el.color };"></span>${ el.labelName }</td>
                                                    <td>${ rate == '--' ? '--' : rate + '%' }</td>
                                                    <td>${ el.humanpropertyNum }</td>
                                                </tr>
                                            `
                                        }).join('')
                                    }
                                </table>
                            `
                        } else return ''
                    },
                    backgroundColor: 'rgba(40, 39, 41, .8)',
                    textStyle: { color: '#fff', fontSize: 12 },
                    padding: 10
                }
            })

            this.barChart.resize()

            // 折线图鼠标移动到上面渲染当前块数据饼图 触发 updateAxisPointer 事件
            let allPieData = this.pieData
            let allNum = this.pieStrData.num
            let dataIndex = -1
            this.barChart.on('updateAxisPointer', e => {
                if (e.axesInfo.length) {
                    if (dataIndex != e.dataIndex) { // 增加判断 防止重复渲染
                        dataIndex = e.dataIndex
                        let item = this.barData[dataIndex] || {}
                        this.pieStrData.num = item.humanpropertyNum || 0
                        this.pieData = item.humanpropertyLabelList || []
                        this.drawPie()
                    }
                } else {
                    if (dataIndex != -1) { // 增加判断 防止重复渲染
                        dataIndex = -1
                        this.pieStrData.num = allNum
                        this.pieData = allPieData
                        this.drawPie()
                    }
                }
            })
        },
        handleChart (data, none) {
            this.drawPie()
            this.drawBar()
        },
        draw (chart, options) {
            chart && chart.setOption(options, true) // 第二个参数传true 表示不和上次数据合并 消除上次数据影响
        }
    }
}
</script>

<style lang="sass" scoped>
.header_title
    text-align: center
    font-weight: 600
    font-size: 18px
    line-height: 24px
.main
    max-height: 490px
    overflow: auto
    color: #282729
    ::v-deep .el-table
        border-top: none
        height: 100%
        .el-table__header
            background: #F1F1F1
            .cell
                border-right: 1px solid #D4D4D4
                color: #282729
            .is-leaf
                border-right: none
                background: #F1F1F1
        .el-table__row
            td
                padding: 10px 0
        .current-row td
            background: rgba(#FF3973, .2)
    .page_box
        height: 60px
        padding: 10px 20px
        bottom: 0
        border: 1px solid #E9E9E9
.footer
    padding: 15px 0
    border-top: 1px solid #E9E9E9
    text-align: center
    .close_button
        width: 120px
        height: 30px
        background: linear-gradient(315deg, rgba(255, 132, 109, 1) 0%, rgba(255, 57, 115, 1) 100%)
        border-radius: 4px
        border: none
        cursor: pointer
        color: #FFF
        &:last-child
            border: 1px solid #d4d4d4
            background: #ffffff
            color: #282729
            margin-left: 20px
::v-deep .el-dialog
    border-radius: 8px
    .el-dialog__header
        padding: 12px 0
        border-bottom: 1px solid #E9E9E9
    .el-dialog__headerbtn
        top: 17px
        right: 17px
        font-weight: 600
        color: #282729
    .el-dialog__body
        padding: 20px
    .el-dialog__footer
        padding: 0

.crowd_data
    margin-left: auto !important
    color: #282729
    .title
        height: 40px
        line-height: 40px
        font-weight: bold
        border-bottom: 1px solid #E9E9E9
        margin: 0
        text-align: left
        padding-left: 23px
        span
            font-size: 12px
            color: #878A92
            margin-left: 10px
            font-weight: normal

</style>

<style lang="scss">
.del_pop.report {
    text-align: center;
    .el-dialog__footer {
        text-align: center;
    }
}
.crowd_data_uf_pop {
  .el-dialog__header {
      text-align: center;
  }
  .el-dialog__body {
    padding: 20px;
    background: #FBFCFD;
    .ctn {
        background: #fff;
        border: 1px solid #EAEBF0;
        .title {
            height: 40px;
            line-height: 40px;
            font-weight: bold;
            border-bottom: 1px solid #E9E9E9;
            margin: 0;
            text-align: left;
            padding-left: 23px;
            span {
                font-size: 12px;
                color: #878A92;
                margin-left: 10px;
                font-weight: normal;
            }
        }
    }
  }
  .el-dialog__footer {
    padding: 0;
    text-align: center;
  }
}
</style>
